import { Component, OnInit } from '@angular/core';
import { NavigationExtras, Router, ActivatedRoute } from '@angular/router';
import { StoreService } from 'src/app/services/store.service';
import { ToastService } from 'src/app/services/toast.service';
import { NavController } from '@ionic/angular';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-cart',
  templateUrl: './cart.page.html',
  styleUrls: ['./cart.page.scss'],
})
export class CartPage implements OnInit {
  productCart: any;
  cartItems: any = [];
  cartTotal: any = 0
  userId: any = localStorage.getItem('userId');
  cartNetAmount: any;
  cartGSTAmount: any;
  DeliveryFee: any;
  noDataImage: boolean;
  isLoading: boolean = false;
  spotCoins: any;
  spotCash: any;
  cart: any;
  data: any;
  n: any = [];
  check: boolean;
  a:boolean=false;
  deliveryFeesAmount:any=0;
  recommendations: any;
  city = localStorage.getItem('city');
  productId: any;
  pin: any;
  prodId: any;
  detailOfProduct: any;
  recommendations1: any;
  recommendations3: any;
  recommendations2: any;
  recommendations4: any;
  constructor(private userService: UserService, private routerActivate: ActivatedRoute, private router: Router, private authService: StoreService, private toast: ToastService, private navController: NavController) { this.loadCartItems() }
  ngOnInit() {
    this.checkk()
    this.handleSubscription()
    this.loadCartItems()

    this.userService.cartUpdated.subscribe(res => {
      let cart = localStorage.getItem('cart');
      if(cart){
        this.n = JSON.parse(cart).length;

    console.log("userService cartUpdated n", this.n)
      
    this.productId=localStorage.getItem("productId")
      }
    })
  
    this.productId=localStorage.getItem("productId")
 
    // document.getElementById('modal-one').style.display='none'; 
  }

  checkk() {
    var check = JSON.parse(localStorage.getItem('cart'))
    if (check) {
      if (check.length > 0) {
        this.check = true;
      } else {
        this.check = false;
      }
    } else {
      this.check = false;
    }
  }
  ionViewDidEnter() {
    this.loadCartItems()
    this.checkk()
  }

  handleSubscription() {
    this.loadCartItems()
  }

  loadCartItems() {
    this.checkk();
    // console.log(this.check)
    let data = {
      cart: JSON.parse(localStorage.getItem('cart')).filter(n => n)
    }
    this.authService.getcart(data).subscribe((res) => {
      // console.log(res)
      this.cartItems = res;
      this.isLoading = true;
      this.calcCartTotal();
      this.productrecommendations()
    })

  }

  async calcCartTotal() {
        this.cartTotal = 0
        // console.log("gcgvchvchvbchvbjvbjvbjnvbnjvb")
        for (var x in this.cartItems) {
          if(localStorage.getItem('retailerEnabled')=="1"){
            this.cartTotal = this.cartTotal + (this.cartItems[x].wholesaleAmount * this.cartItems[x].qty)
          }else{
            this.cartTotal = this.cartTotal + (this.cartItems[x].purchaseAmount * this.cartItems[x].qty)
          }
          this.deliveryFess();
          //console.log("hi")
        }
      }
    

  // netAmountCalculation(purchaseAmount: any, qantity: any, gstper: any) {
  //   return (purchaseAmount * qantity) / (1 + gstper / 100)
  // }

  deliveryFess(){
        let formdata = {
          "productId": JSON.parse(localStorage.getItem('cart')).filter(n => n),
          "amount":this.cartTotal
        }
        console.log("Delivery Fees Amount ",formdata)
        this.authService.deliveryFee(formdata).subscribe((res) => {
           console.log("reponse from delivery fees amount api",res)
          this.deliveryFeesAmount = res.deliveryFees;
         
        })
       }
    


   productCheckout() {
        if (this.userService.uid) {
          this.cartItems.forEach(element => {
            element.NetAmount = Math.round((element.purchaseAmount * element.qty) / (1 + element.gst_per / 100));
            element.GST_tax_Amount = Math.round((element.purchaseAmount * element.qty) - ((element.purchaseAmount * element.qty) / (1 + element.gst_per / 100)));
            element.DaCommissionTotalFee = (Math.round((element.purchaseAmount * element.qty) / (1 + element.gst_per / 100))) * (element.DaCommissionFee) / 100;
          });
          //  let DaDeliveryFee="0"
          let orderObject = {
            totalAmount: this.cartTotal,
            productDetailArr: this.cartItems,
            deliveryfees: this.deliveryFeesAmount,
          }
          this.userService.setContext('cart data', {
            totalAmount: this.cartTotal,
            productDetailArr: JSON.stringify(this.cartItems),
            DeliveryFee: 0
          });
          let name = '[LOG] GoTo Checkout';
          var error = new Error();
          error.name = name;
          // error.message = JSON.stringify(orderObject);
          this.userService.sendException(error)
          this.userService.cartObject = orderObject;
          let navigationParams: NavigationExtras = { state: { checkoutObj: orderObject, isPromoActiveFlag: "C", promotionID: "", spotCoins: this.spotCoins, spotcash: this.spotCash, backPageFlag: { backPageFlagInfo: "cart" } } };
          this.router.navigate(['checkout'], navigationParams)
        } else {
          this.router.navigate(['/login'])
        }
      }
    



  includeDelFeeTotal() {
    // console.log("Add",this.DaDeliveryFee)
    return this.DeliveryFee + this.cartTotal
  }
  goBack() {
    this.navController.pop();
  }

  handleAddToCart(item) {
    ++item.qty;
    this.cart = []
    let cart = localStorage.getItem("cart");
    if (cart) {
      this.cart = JSON.parse(cart);
      console.log("cart ", this.cart)
      let filtered = this.cart.filter(product => product.id == item._id)
      let index = this.cart.indexOf(filtered[0])
      this.cart[index]['qty'] = item.qty;
      localStorage.setItem('cart', JSON.stringify(this.cart))
    }
    this.calcCartTotal();
    // this.loadCartItems();


  }
  deleteFromCart(item) {
    if (item.qty > 1) {

      --item.qty;
      this.cart = []
      let cart = localStorage.getItem("cart");
      if (cart) {
        this.cart = JSON.parse(cart);
        console.log("cart ", this.cart)
        let filtered = this.cart.filter(product => product.id == item._id)
        let index = this.cart.indexOf(filtered[0])
        this.cart[index]['qty'] = item.qty;
        localStorage.setItem('cart', JSON.stringify(this.cart))
      }
      this.calcCartTotal();
      // this.loadCartItems();

    }

    this.userService.cartUpdated.next(true);
  }


  productDetail(productItem: any) {
    console.log("hello hi ", productItem)
    this.router.navigate(['./product-detail/' + productItem._id])
  }


  ionViewDidLeave() {
    this.cartItems = []
    this.cartTotal = 0
  }

  WishlistNav() {
    this.router.navigate(['/wishlist'])
  }
  home(){
    this.router.navigate(['/'])
    
  }

  deleteCart(productObj) {
    console.log("productObj ", productObj)
    this.cart = []
    let cart = localStorage.getItem("cart");
    if (cart) {
      this.cart = JSON.parse(cart);
      console.log("cart ", this.cart)
      let filtered = this.cart.filter(product => product.id == productObj)
      console.log("filtered ", filtered)
      if (filtered.length == 0) {


      } else {

        let index = this.cart.indexOf(filtered[0]);
        console.log("index ", index)
        this.cart.splice(index, 1)
        localStorage.setItem('cart', JSON.stringify(this.cart))
        //this.show=null

      }
    }
    this.calcCartTotal();
    this.loadCartItems();

    this.userService.cartUpdated.next(true);

  }

  handleMissingImage($event){
    console.log($event)
    console.log("hello error");
    ($event.target as HTMLImageElement).style.display = 'none'
    this.a=true;
  }
  isActive(){
    if(localStorage.getItem('retailerEnabled')=="1")
    {
      return true
    }
  }
  productrecommendations(){
    let formdata = {
      productId:this.productId, city: "Kanpur"
    }
    console.log("fffffffffffffffff",formdata)
    this.authService.recommendedProducts1(formdata).subscribe((res)=>{
     this.recommendations=res;
     console.log("recommendations",this.recommendations)
    })
  }
 
}
